import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-repeat',
	templateUrl: './icon-repeat.component.svg',
})
export class IconRepeatComponent {}
